import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AuthenticationGuard} from '@modweb5/sharedQuards/authentication.guard';

import {AppInitService} from './config/appInit.service';

import {routing} from './app.routing';

import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
		BrowserAnimationsModule,
    HttpClientModule,
		routing
  ],
	exports: [
	],
	providers: [
		AuthenticationGuard,
		AppInitService,
		{
			provide: APP_INITIALIZER,
			useFactory: initAppService, 
			deps: [AppInitService], // AppInitService je exportovaná třída service
			multi: true
		},
	],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function initAppService(appService: AppInitService) {
  return () => appService.someInit();
}

